import { ProcessContentAssistantActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/ProcessContentAssistantActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { ActionFeatures } from '../ActionFeatures';
import { VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import '../Actions.scss';
export class ProcessContentAssistantActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'CurrentApplicationService', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', '$stateParams', 'ArtificialIntellingeceConfigurationsService'];
    constructor(close, action, $onStateChanged, CurrentApplicationService, $translate, $rootScope, UndoRedoService, state, $timeout, $stateParams, ArtificialIntellingeceConfigurationsService) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope);
        this.CurrentApplicationService = CurrentApplicationService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.ArtificialIntellingeceConfigurationsService = ArtificialIntellingeceConfigurationsService;
        this.isEditing = false;
        this.variableName = '{{context.variableName}}';
        this.isConfigurationsApplicationGetEnabled = false;
        this.init();
    }
    async init() {
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
        this.isConfigurationsApplicationGetEnabled = await ActionFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.checkContentV2();
        // This feature is not supported by subflows
        if (!this.$stateParams.startsWith('subflow-')) {
            this.application = await this.CurrentApplicationService.fetchApplication();
        }
        this.$timeout(async () => {
            this.processContentAssistantForm.text.$setDirty();
            this.processContentAssistantForm.tags.$setDirty();
            this.processContentAssistantForm.score.$setDirty();
            this.processContentAssistantForm.outputVariable.$setDirty();
            this.checkValidVariableName();
            this.checkScore();
            this.handleSaveAction();
            this.checkValidInputs();
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
    }
    startEditing() {
        const input = document.getElementById('set-content-assistant-process-title');
        if (input) {
            input.focus();
        }
    }
    checkValidInputs() {
        if (!this.action.settings) {
            this.save();
        }
    }
    async checkContentV2() {
        const isContentAssistantV2Enabled = await this.isContentAssistantV2Enabled();
        this.action.settings.v2 = isContentAssistantV2Enabled;
        if (!isContentAssistantV2Enabled) {
            const variableField = document.querySelector('blip-input-dpr[field-name="tags"]');
            variableField.setAttribute('hidden', isContentAssistantV2Enabled);
        }
        this.save();
    }
    validateOutputVariable() {
        const isValid = this.checkVariableRegex();
        this.processContentAssistantForm.outputVariable.$invalid = isValid;
        this.processContentAssistantForm.outputVariable.$valid = !isValid;
        this.processContentAssistantForm.outputVariable.$setDirty();
    }
    handleSaveAction() {
        this.validateOutputVariable();
        this.save();
    }
    checkValidVariableName() {
        if (!this.checkVariableRegex()) {
            this.processContentAssistantForm.outputVariable.$invalid = true;
            this.processContentAssistantForm.outputVariable.$valid = false;
        }
    }
    checkVariableRegex() {
        return (this.action.settings.outputVariable &&
            this.action.settings.outputVariable.match(VARIABLE_VALIDATION_REGEX));
    }
    checkText() {
        if (!this.action.settings.text) {
            this.processContentAssistantForm.text.$invalid = true;
            this.processContentAssistantForm.text.$valid = false;
        }
        this.save();
    }
    checkTag() {
        if (!this.action.settings.tags) {
            this.processContentAssistantForm.tags.$invalid = true;
            this.processContentAssistantForm.tags.$valid = false;
        }
        this.save();
    }
    checkScore() {
        if (this.action.settings.score) {
            this.action.settings.score = this.action.settings.score.replace(/[^0-9]/, '');
        }
        if (this.action.settings.score < 0 || this.action.settings.score > 100) {
            this.processContentAssistantForm.score.$invalid = true;
            this.processContentAssistantForm.score.$valid = false;
        }
        this.save();
    }
    onBlur() {
        this.isEditing = false;
        if (this.$title.length === 0) {
            this.$title = this.$translate.instant('builder-tabs-actions.processContentAssistant.title');
            this.save();
        }
    }
    async isContentAssistantV2Enabled() {
        return await this.ArtificialIntellingeceConfigurationsService.isV2ConfigurationEnabled(this.isConfigurationsApplicationGetEnabled) ?? false;
    }
    create() {
        return new ProcessContentAssistantActionSettings();
    }
}
ProcessContentAssistantActionController.$inject = ['close', 'action', '$onStateChanged', 'CurrentApplicationService', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', '$stateParams', 'ArtificialIntellingeceConfigurationsService'];
